import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { G, Path, Defs, ClipPath, Circle } from 'react-native-svg';

const DivideIcon = React.memo(
  (props: {
    size: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    const iconColor = props.color ?? '#333';
    const iconSize = props.size ?? 27;

    return (
      <View style={props.containerStyle}>
        <Svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 27 27"
          fill="none"
          {...props}
        >
          <G
            clipPath="url(#clip0_682_49674)"
            stroke={iconColor}
            strokeWidth={2.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <Path d="M4 13.5h19" />
            <Circle cx="13.5" cy="7" r="1.5" fill={iconColor} stroke="none" />
            <Circle cx="13.5" cy="20" r="1.5" fill={iconColor} stroke="none" />
          </G>
          <Defs>
            <ClipPath id="clip0_682_49674">
              <Path fill="#fff" transform="translate(0 .5)" d="M0 0H27V27H0z" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { DivideIcon };
